import { Observable } from "rxjs";
import { BaseResponse, DataUsageStatistics, GetPaymentHistoryRequest, PaymentHistoryResponse, SimStatusResponse } from "src/app/core/models";
import { Upload } from "src/app/core/services";
export abstract class SelfCareData {
    abstract changeCreditLimit(request: any): Observable<any>;
    abstract getDashboardGSMData(request: any): Observable<any>;
    abstract getSecondaryMSISDNS(request: any): Observable<BaseResponse<any>>;
    abstract getSecondaryMSISDNS2(request: any): Observable<BaseResponse<any>>;
    abstract enableDisableService(request:any): Observable<BaseResponse<any>>;
    abstract checkLoanStatus(request: { msisdn: string }): Observable<BaseResponse<any>>;
    abstract reverseTransaction(request: { msisdn: string; transactionId: string }): Observable<BaseResponse<any>>;
    abstract getCorporationAccountCodes(request: any): Observable<BaseResponse<any>>;
    abstract getSubscriberInfo(request: any): Observable<BaseResponse<any>>;
    abstract uploadCampaignFile(files: File[], path?: string, smsBalance?: any): Observable<Upload>;
    abstract addNewCampaign(request: any): Observable<any>;
    abstract getAllCampaigns(request: any): Observable<any>;
    abstract getBalanceInfoReports(): Observable<BaseResponse<any>>;
    abstract getBalanceInfoReportById(reportId: string): Observable<BaseResponse<any>>;
    abstract generateBalanceReport(msisdn: string): Observable<BaseResponse<any>>;
    abstract getAllSenderIdsConfig(): Observable<BaseResponse<any>>;
    abstract deleteBulkSMSBulk(id: number): Observable<any>;
    abstract getSalesAgentData(request: any): Observable<any>;
    abstract getOverdueBillsInfo(request: any): Observable<any>;
    abstract getSingleSmsStatus(campaignId: number): Observable<any>;
    abstract getEnterpriseSimStatuses(msisdn: string): Observable<BaseResponse<SimStatusResponse>>;
    abstract getEnterpriseSimDataUsageStatistics(msisdn: string): Observable<BaseResponse<DataUsageStatistics>>;
    abstract getPaymentHistory(request: GetPaymentHistoryRequest): Observable<BaseResponse<PaymentHistoryResponse>>;

}
